import { IGradingTemplateSurveyDetail } from '@lb/api/core/interfaces/igrading-template.interface';
import { ILessonListItem } from '@lb/api/mylb/interfaces';

/** Core.GradingTemplateSurvey.RespondentType — 1 = Learner, 2 = Instructor. */
export const SURVEY_RESPONDENT_LEARNER = 1;
export const SURVEY_RESPONDENT_INSTRUCTOR = 2;

/** Lead time used when a survey carries none — matches the column default on Core.GradingTemplateSurvey. */
export const DEFAULT_SURVEY_AVAILABLE_DAYS_BEFORE = 7;

const MS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * Whether a survey may be answered yet on the lesson it targets.
 *
 * A survey is attached to a lesson by semesterLessonTypeID, which says *which* lesson but not *when* —
 * so a mid-semester survey used to be answerable from the moment the schedule was generated. The
 * survey's own availableDaysBefore closes that gap: it opens that many days before its lesson and
 * stays open afterwards (there is no submission deadline). Reading the lesson's current date means a
 * reschedule carries the window with it.
 *
 * Compared as instants, so the lesson's timezone does not enter into it. The submission endpoint
 * enforces the same rule — this only decides what the UI offers.
 */
export function isSurveyAvailable(
	lesson: Pick<ILessonListItem, 'lessonDate'>,
	survey: Pick<IGradingTemplateSurveyDetail, 'availableDaysBefore'>,
	now: Date = new Date()
): boolean {
	if (!lesson.lessonDate) return true;

	const lessonTime = new Date(lesson.lessonDate).getTime();
	if (Number.isNaN(lessonTime)) return true;

	const daysBefore = survey.availableDaysBefore ?? DEFAULT_SURVEY_AVAILABLE_DAYS_BEFORE;

	return now.getTime() >= lessonTime - daysBefore * MS_PER_DAY;
}
